<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-campanha') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"    
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="campanhasSelecionadas.length === 0 && !isEdit"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="search-and-filter" v-if="!isEdit">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
        </div>

        <div class="registry-wrapper" v-if="!isEdit">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="campanhas"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                sticky-header
                height="50vh"
                :checked-rows.sync="campanhasSelecionadas"
                :custom-is-checked="(selecionados, linha) => selecionados.idcampanha === linha.idcampanha"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.label) : ''"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0 mt-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import CampanhaService from "@/services/vendas/CampanhaService";
import AssUsuarioCampanhaService from "@/services/colaborador/AssUsuarioCampanhaService";
import Message from "@/models/Message";

export default {
    props: {
        idUsuario: 0,
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            service: new CampanhaService(this.$http, this.$router),
            usuariocampanhaservice: new AssUsuarioCampanhaService(this.$http, this.$router),
            campanhas: [],
            isLoading: false,
            isEmpty: false,
            isEdit: false,
            asscampanhausuario: {},
            fields: [
                {key: 'descricao', label: 'descricao', width: null, sortable: true, sortFn: null},
                {key: 'datavalidadeformatada', label: 'data-validade', width: null, sortable: true, sortFn: null},
            ],
            campanhasSelecionadas: [],
            idusuario: 0,
            debouncedOnSearch: null,
            queryFilter: '.*',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
            msgs: [],
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        if(this.selected){
            this.isEdit = true
            this.loadAssUsuarioCampanha()
        }
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }
            this.findAllNaoVinculado(currentPage)
        },
        findAllNaoVinculado(currentPage = 1){
            this.isLoading = true;
            this.service
            .findAllNaoVinculadoUsuario(
                this.idUsuario,
                currentPage - 1,
                this.pagination.perPage,
                this.order,
                this.column,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.campanhas = value;
                this.isEmpty = this.campanhas.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        generateId(numberId){
            return this.$route.name+'-usuario-'+numberId;
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map(m => {
                return {
                    idcampanha: m.idcampanha,
                    descricao: m.descricao,
                    datavalidadeformatada: m.datavalidadeformatada
                };
            });
        },
        mapCampanhaUsuario(item) {
            this.asscampanhausuario.idassusuariocampanha = item.idassusuariocampanha
            this.asscampanhausuario.idcampanha = item.idcampanha
            this.asscampanhausuario.nome = item.nome
        },
        mapOnSave(itens) {
            return itens.map(m => {
                return {
                    idusuario: this.idUsuario,
                    idcampanha: m.idcampanha
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.campanhasSelecionadas.length > 0) {
                this.isLoading = true;
                this.usuariocampanhaservice.save(this.mapOnSave(this.campanhasSelecionadas))
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.onFecharModal()
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-campanha', true));
                this.isLoading = false;
            }
        },
        onFecharModal(){
            this.isEdit = false
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>